// 生豆の合計重量に上限を設ける。
//   - 商品ページ: 数量欄に max を張り、上限を超える数量では追加させない
//   - カートページ: 数量欄に max を張り、上限を超える値に増やせないようにする
//   - チェックアウト直前: もう一度カート全体を見る
// 判定はカート内の合計なので、複数回に分けて入れても合算される。
(() => {
  const configEl = document.getElementById('coban-weight-limit-config');
  if (!configEl) return;

  let config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  const limit = config.limitGrams;
  const targetIds = new Set(config.productIds || []);
  const variantGrams = config.variantGrams || {};
  if (!limit || targetIds.size === 0) return;

  const format = (grams) => `${Math.round((grams / 1000) * 10) / 10}kg`;

  // 上限は「limit ちょうどまで可、超えたら不可」。150kg は買えて 151kg は買えない。
  const maxUnits = (unit, otherGrams) => {
    if (!unit) return null;
    const room = limit - otherGrams;
    if (room <= 0) return 0;
    return Math.max(0, Math.floor(room / unit));
  };

  // カートに入っている対象商品の合計重量と、バリエーションごとの内訳
  const readCart = async () => {
    const root = window.Shopify?.routes?.root || '/';
    const res = await fetch(`${root}cart.js`);
    const cart = await res.json();
    const byVariant = new Map();
    let total = 0;
    cart.items.forEach((item) => {
      if (!targetIds.has(item.product_id)) return;
      const grams = item.grams * item.quantity;
      total += grams;
      byVariant.set(String(item.variant_id), (byVariant.get(String(item.variant_id)) || 0) + grams);
    });
    return { total, byVariant };
  };

  const notify = (host, total) => {
    const message = `${config.label}は合計 ${format(limit)} までご購入いただけます(現在の合計 ${format(total)})。`;
    const parent = host || document.querySelector('.cart__footer') || document.body;
    let box = parent.querySelector('.coban-weight-limit-note');
    if (!box) {
      box = document.createElement('p');
      box.className = 'coban-weight-limit-note';
      box.setAttribute('role', 'alert');
      parent.prepend(box);
    }
    box.textContent = message;
    box.scrollIntoView?.({ block: 'center', behavior: 'smooth' });
  };

  // フォームに紐づく入力を取る。数量欄は form 属性で外に置かれていることがあり、
  // querySelector では拾えない。form.elements は form 属性の関連付けも含む。
  const field = (form, name) => (form.elements ? form.elements[name] : null);

  const addFormUnit = (form) => {
    const idInput = field(form, 'id');
    if (!idInput || !idInput.value) return { unit: 0, variantId: null };
    return { unit: variantGrams[idInput.value] || 0, variantId: String(idInput.value) };
  };

  // 追加しようとしている分の重量。対象外の商品なら 0
  const pendingGrams = (form) => {
    const { unit } = addFormUnit(form);
    if (!unit) return 0;
    const qtyInput = field(form, 'quantity');
    const qty = qtyInput ? Number(qtyInput.value) || 1 : 1;
    return unit * qty;
  };

  // 残り枠が減っている理由を数量欄の下に出す。
  // これが無いと「なぜか 50 までしか選べない」と見えてしまう。
  const showRemaining = (qtyInput, cartGrams, unit, max) => {
    const holder = qtyInput.closest('.product-form__quantity') || qtyInput.parentElement;
    if (!holder) return;
    let el = holder.querySelector('.coban-weight-limit-hint');
    if (cartGrams <= 0) {
      el?.remove();
      return;
    }
    if (!el) {
      el = document.createElement('p');
      el.className = 'coban-weight-limit-hint';
      holder.appendChild(el);
    }
    el.textContent = `カートに既に ${format(cartGrams)} 入っているため、あと ${format(max * unit)} まで追加できます。`;
  };

  // 商品ページ: 数量欄に max を張る
  const applyProductMax = async () => {
    const forms = [...document.querySelectorAll('form[action*="/cart/add"]')];
    if (forms.length === 0) return;
    const { total } = await readCart();
    forms.forEach((form) => {
      const { unit } = addFormUnit(form);
      const qtyInput = field(form, 'quantity');
      if (!unit || !qtyInput) return;
      const max = maxUnits(unit, total);
      qtyInput.max = String(max);
      if (Number(qtyInput.value) > max) qtyInput.value = String(Math.max(1, max));
      showRemaining(qtyInput, total, unit, max);
    });
  };

  // カートページ: 行ごとに max を張る。その行以外の合計を引いた残りが上限
  const applyCartMax = async () => {
    const inputs = [...document.querySelectorAll('.quantity__input[data-quantity-variant-id]')];
    if (inputs.length === 0) return;
    const { total, byVariant } = await readCart();
    inputs.forEach((input) => {
      const variantId = String(input.dataset.quantityVariantId);
      const unit = variantGrams[variantId];
      if (!unit) return;
      const others = total - (byVariant.get(variantId) || 0);
      const max = maxUnits(unit, others);
      input.max = String(max);
      if (Number(input.value) > max) input.value = String(max);
    });
  };

  const applyAll = () => {
    applyProductMax();
    applyCartMax();
  };

  // カート数量の増加を確定前に丸める。max を超える値は送らせない
  document.addEventListener(
    'change',
    (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement)) return;
      if (!input.classList.contains('quantity__input')) return;
      const max = Number(input.max);
      if (!input.max || Number.isNaN(max)) return;
      if (Number(input.value) > max) {
        input.value = String(max);
        notify(input.closest('.cart-item') || null, limit);
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.action || !form.action.includes('/cart/add')) return;
      if (form.dataset.cobanWeightChecked === 'true') return;

      const pending = pendingGrams(form);
      if (!pending) return; // 重量未設定 or 対象外

      event.preventDefault();
      event.stopImmediatePropagation();

      const { total: cartTotal } = await readCart();
      const total = cartTotal + pending;
      if (total > limit) {
        notify(form, total);
        applyProductMax();
        return;
      }

      form.dataset.cobanWeightChecked = 'true';
      form.requestSubmit ? form.requestSubmit() : form.submit();
      delete form.dataset.cobanWeightChecked;
    },
    true
  );

  // カートページ: チェックアウトへ進む直前にもう一度見る
  document.addEventListener(
    'click',
    async (event) => {
      const button = event.target.closest('[name="checkout"]');
      if (!button) return;
      if (button.dataset.cobanWeightChecked === 'true') return;

      event.preventDefault();
      const { total } = await readCart();
      if (total > limit) {
        notify(null, total);
        return;
      }

      button.dataset.cobanWeightChecked = 'true';
      button.click();
      delete button.dataset.cobanWeightChecked;
    },
    true
  );

  // Dawn はカート更新でセクションを差し替えるため、張り直しが要る。
  // 商品ページ側も、別タブでカートを空にした / 戻るで復元された場合に
  // 古い max が残ると「なぜか少ししか選べない」状態になるので張り直す。
  const watch = () => {
    const host = document.getElementById('main-cart-items');
    if (host) new MutationObserver(() => applyCartMax()).observe(host, { childList: true, subtree: true });

    window.addEventListener('pageshow', applyAll);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) applyAll();
    });
    // カート追加後もカート内容が変わるため
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (form instanceof HTMLFormElement && form.action && form.action.includes('/cart/add')) {
        setTimeout(applyAll, 600);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      applyAll();
      watch();
    });
  } else {
    applyAll();
    watch();
  }
})();

